import { LivechatRequestFields } from "./livechat-request-fields";

export class LivechatRequestBody {


    ignore_required = true;
    ignore_bot = false;
    department = [1]
    fields: LivechatRequestFields = new LivechatRequestFields();
    encData?: String;
    chat_id?: String;
    hash?: String;
    sourceSystem= "MHC";
    verificationPerformed = false;
}
